import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

function ServiceSupportTile(props) {
  const [renderType, setRenderType] = useState("");
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const popoverRef = useRef(null);
  const history = useHistory()
  var profile = props.profile;
  const serviceSupportDetails = props.data?.[0]?.ContentRuleZone?.[0]?.attributes
  const mainImage = props.data?.[0]?.ContentRuleZone?.[0]?.menuImage
  const  altText = props.data?.[0]?.ContentRuleZone?.[0]?.attributes?.altText


  useEffect(() => {
    if (serviceSupportDetails.renderPosition) {
      setRenderType(serviceSupportDetails.renderPosition)
    }
  }, [serviceSupportDetails])

  const hadleServiceSupport = (event) => {
    event.preventDefault();
    if (serviceSupportDetails.link) {
      history.push(`${serviceSupportDetails.link}`)
    }
  }

  useEffect(() => {
    if ((window.innerWidth > 991)) {
      setIsPopoverOpen(false);
    }
  }, []);

  const handlePopoverToggle = (event) => {
    event.preventDefault();
    if (window.innerWidth <= 991) {
      setIsPopoverOpen(!isPopoverOpen);
    }
  };

  useEffect(() => {
    const handleCloseButtonClick = (event) => {
        if (event.target && event.target.matches('.btn-close')) {
            setIsPopoverOpen(false);
        }
    };

    const currentPopover = popoverRef.current;
    if (currentPopover) {
        currentPopover.addEventListener('click', handleCloseButtonClick);
    }

    // Clean up event listener on unmount or when content changes
    return () => {
        if (currentPopover) {
            currentPopover.removeEventListener('click', handleCloseButtonClick);
        }
    };
}, [isPopoverOpen]);
  return (
    <>
      <li className={`text-center icon-width-popup popover__wrapper c-contact-image ${serviceSupportDetails?.additionalCss ? serviceSupportDetails.additionalCss : ""}`}>

        {renderType === "TextOnly" ? <Link className='link-icon-style c-utility-nav-label' to={`${serviceSupportDetails.link ? serviceSupportDetails.link : "#"}`} >
          <span className='d-block nav-text-hover' style={{ cursor: "pointer" }}>{serviceSupportDetails?.displayName ? serviceSupportDetails.displayName : ""}</span>
        </Link>
          : renderType === "IconOnly" ? <Link className='link-icon-style c-utility-nav-label' to={`${serviceSupportDetails.link ? serviceSupportDetails.link : "#"}`} onClick={handlePopoverToggle}>
            {serviceSupportDetails.menuIcon ? <i className={`${serviceSupportDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img' /> : ""}
          </Link>
            : renderType === "LeftIconThenText" ? <Link className='link-icon-style c-utility-nav-label d-flex' to={`${serviceSupportDetails.link ? serviceSupportDetails.link : "#"}`}>
              {serviceSupportDetails.menuIcon ? <i className={`${serviceSupportDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img' /> : ""}
              <span className='d-block nav-text-hover mx-2' style={{ cursor: "pointer" }}>{serviceSupportDetails?.displayName ? serviceSupportDetails.displayName : ""}</span>
            </Link>
              : renderType === "LeftTextThenIcon" ? <Link className='link-icon-style c-utility-nav-label d-flex' to={`${serviceSupportDetails.link ? serviceSupportDetails.link : "#"}`}>
                <span className='d-block nav-text-hover mx-2' style={{ cursor: "pointer" }}>{serviceSupportDetails?.displayName ? serviceSupportDetails.displayName : ""}</span>
                {serviceSupportDetails.menuIcon ? <i className={`${serviceSupportDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img' /> : ""}
              </Link>
                : renderType === "TextAboveIcon" ? <Link className='link-icon-style c-utility-nav-label' to={`${serviceSupportDetails.link ? serviceSupportDetails.link : "#"}`}>
                  {serviceSupportDetails.menuIcon ? <i className={`${serviceSupportDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img' /> : ""}
                  <span className='d-block nav-text-hover mt-3' style={{ cursor: "pointer" }}>{serviceSupportDetails?.displayName ? serviceSupportDetails.displayName : ""}</span>
                </Link>
                  : renderType === "TextBelowIcon" ? <Link className='link-icon-style c-utility-nav-label' to={`${serviceSupportDetails.link ? serviceSupportDetails.link : "#"}`}>
                    <span className='d-block nav-text-hover mb-3' style={{ cursor: "pointer" }}>{serviceSupportDetails?.displayName ? serviceSupportDetails.displayName : ""}</span>
                    {serviceSupportDetails.menuIcon ? <i className={`${serviceSupportDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img' /> : ""}
                  </Link>
                    : ""}

        {props && props.targerter ?
          <>
           

            <div className='d-lg-block d-none '>
              <div dangerouslySetInnerHTML={{ __html: props.targerter ? props.targerter : '' }}></div>
            </div>
            <div className={`d-lg-none d-block`} >
              <div className={`c-utility-nav-content checkout-service-support  ${isPopoverOpen ? 'open' : ''}`} dangerouslySetInnerHTML={{ __html: props.targerter }} ref={popoverRef}></div>
            </div></> :
          <div className="popover-myaccount-content popover__content service-support">
            <div className='col-12 row'>
              <div className='col-7 contact-section'>
                {/* <div className='' style={{ borderBottom: "solid", borderBottomColor: "#d7d7d7" }}>
                  <h5>Contact Us</h5>
                  <p>Our Customer Service team is available from 8.00am to 6.00pm, ET, Monday through Friday. Live chat is available from 8.00am to 5.30pm ET, Monday through Friday. </p>
                  <h6><stong>Call : 800.334.5551</stong></h6>
                  <h6><stong>Fax : 800.222.7112</stong></h6>
                  <h6><stong>Email : <Link to=''>Email Customer Service</Link></stong></h6>
                  <h6><stong>Chat : <Link to=''>Start Live Chat</Link></stong></h6>
                </div> */}
                <dl class="new-support-info">
                  <dt >Call :</dt>
                  <dd class="info-def"><strong>800.334.5551</strong></dd>

                  <dt>Fax :</dt>
                  <dd class="info-def"><strong>800.222.7112</strong></dd>

                  <dt>Email :</dt>
                  <dd class="info-def">
                  <Link to=''>Email Customer Service</Link>
                  </dd>

                  <dt>Chat :</dt>
                  <dd class="info-def">
                      <Link to=''>Start Live Chat</Link>
                  </dd>
                </dl>
                <div className='mt-3'>
                  <h5>International Sales & Services</h5>
                  <div className='d-flex'>
                    <div className='col-9'> <p>We serve educators in more than 170 countires worldwide&nbsp;<Link to="">Create a quote request on our website</Link>&nbsp;or contact our International Sales Team. </p></div>
                    <div className='international-sales-img'> <img className='' src="https://www.carolina.com/images/icon_earth.png" alt=""></img></div>
                  </div>

                  <div class="form-submit international-order-btn">
                    <Link class="btn btn-primary" to="/help/international-ordering">International Ordering Information</Link>
                  </div>

                </div>
              </div>
              <div className='service-support-section'>
                <div>
                  <h5>Service & Support</h5>
                  <div className='mx-2'>
                    <Link className='row' to='/help/contact-us'>Customer Service & Technical Support</Link>
                    <Link className='row' to='/our-company/returns-exchanges-satisfaction-guarantee'>Returns & Replacement</Link>
                    <Link className='row' to='/help/living-delivery'>Schedule Living Material Delivery</Link>
                    <Link className='row' to='/voucher/redeem.jsp'>Redeem Vouchers</Link>
                    <Link className='row' to='/help/shipping-information'>Shipping Information</Link>
                    <Link className='row' to='/help/credit-application'>Contracts & Buisness Accounts</Link>
                    <Link className='row' to='/help/procurement-punchout-support'>Procurement & Punchout Services</Link>
                    <Link className='row' to='/help/international-ordering'>International Ordering</Link>
                    <Link className='row' to='/help/permits'>USDA Permits for Living Organisms</Link>
                    <Link className='row' to='/help/catalogs'>Carolina@ catalogs</Link>
                    <Link className='row' to='/our-company/about-us'>About Us</Link>
                  </div>
                </div>
                <p className='visit-carolina-help-btn'></p>
                <div class="form-submit visit-carolina-help-btn">
                  <Link class="btn btn-primary" to="/help/visit-carolina">Vist Carolina Help Center</Link>
                </div>
              </div>
            </div>
            <div className='service-support-arrow'></div>
          </div>}
      </li>

    </>
  )
}

export default ServiceSupportTile
